import { createFileRoute } from "@tanstack/react-router";

import { PocEnvironmentPage } from "@/features/poc-environment/poc-environment-page";
import { STATIC_LABELS } from "@/lib/nav-registry";

// ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
// 画面本体は会員側 (`member/poc-environment.tsx`) と共通。
export const Route = createFileRoute("/_authenticated/enterprise/poc-environment")({
  staticData: { crumb: { label: STATIC_LABELS.pocEnvironment } },
  component: PocEnvironmentPage,
});
